import axios from 'axios';

import env from '../env';

const allCareApi = axios.create({
  baseURL: env.ALLCARE_API,
});

export default allCareApi;
